import * as React from 'react';
import { IPost } from '../../types';

interface IProps {
	post: IPost;
}

const BeforeAfterModal = ({ post }: IProps) => {
	return (
		<div className="card pfa-card-modal pfa-modal__body">
			<div className="pfa-card-modal__images">
				{!!post.before_image && (
					<figure
						className="pfa-card-modal__before-figure"
						dangerouslySetInnerHTML={{ __html: post.before_image }}
					/>
				)}
				{!!post.after_image && (
					<figure
						className="pfa-card-modal__after-figure"
						dangerouslySetInnerHTML={{ __html: post.after_image }}
					/>
				)}
			</div>
			{post.images_caption && <p>{post.images_caption}</p>}
			{post.procedure_link && (
				<a
					href={post.procedure_link}
					className="pfa-card-modal__term-button btn btn-primary btn-black"
				>
					Explore {post.procedure_term.name} Procedure
				</a>
			)}
		</div>
	);
};

BeforeAfterModal.displayName = 'BeforeAfterModal';

export default BeforeAfterModal;
